module.exports = __webpack_public_path__ + "admin/img/card_icon_jcb.02ebe254.svg";